// When sidebar_accordion_single_open is enabled, closing all other open
// accordion-disclosures in the same sub-panel whenever one opens.
// Uses capture phase because the native `toggle` event does not bubble.
document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!details.matches('details.accordion__disclosure') || !details.open) return;

  const panel = details.closest('header-sidebar-collapsible-panel');
  if (!panel || !panel.hasAttribute('data-accordion-single-open')) return;

  const subPanel = details.closest('.header-sidebar__sub-panel');
  if (!subPanel) return;

  subPanel.querySelectorAll('accordion-disclosure').forEach((accordion) => {
    if (
      accordion.disclosureElement !== details &&
      accordion.disclosureElement.getAttribute('aria-expanded') === 'true'
    ) {
      accordion.close();
    }
  });
}, true);
